export const initialState = () => ({
	pages: [],
	pagesValidationErrors: false,
	pagesValidationModal: false,
	pagesSkeleton: {
		title: '',
		parentId: 0,
		position: -1,
		published: false,
		slug: '',
		seoDescription: '',
		seoTags: '',
		body: `<h1>Template Title</h1>
				<h2>Template Sub Title</h2>
				<section class="copy">
					<div class="across">
						<div class="images-stacked">
							<img src="/assets/images/Argos_Vehicle.jpg" width="200px" /> 
						</div>
						<div>
							<h3>Template Section Header</h3>
							<p>The ArgosCare Consultancy Team are specialists in the field of compliance.</p>
							<ul>
								<li>List item 1</li>
								<li>List item 2</li>
							</ul>
						</div>
					</div>
				</section>`,
		layout: '',
		settings: {
			"slideshow": {
				"repeat": true,
				"period": 4000
			},
			"productList": false
		},
		files: []
	},

	pagesFiles: [],

	pagesSnippets: [],
	pagesSnippetSkeleton: {
		title: '',
		slug: '',
		body: ''
	}
});

export default initialState();
